import instance from 'utils/axios/instance.axios';
import { REGISTER_RESULT } from './_constant';

export const getRegisterResultById = (id) => instance.get(REGISTER_RESULT.GET_REGISTER_RESULT(id));

export const getRegisterResultByProjectId = (id) =>
  instance.get(REGISTER_RESULT.GET_REGISTER_RESULT_BY_PROJECT_ID(id));

export const createRegisterResult = (body = {}) =>
  instance.post(REGISTER_RESULT.POST_REGISTER_RESULT, body);

export const updateRegisterResult = (body = {}) =>
  instance.patch(REGISTER_RESULT.PATCH_REGISTER_RESULT, body);

export const submitRegisterResult = (body = {}) =>
  instance.post(REGISTER_RESULT.SUBMIT_REGISTER_RESULT, body);

export const downloadPdfFile = (body) =>
  instance.post(REGISTER_RESULT.DOWNLOAD_PDF_FILE, body, { responseType: 'blob' });

export const getDetailRegisterResultById = (projectId) =>
  instance.get(REGISTER_RESULT.GET_DETAIL_REGISTER_RESULT(projectId));

export const downloadRegisterResultFile = (id, filename, type) =>
  instance.get(REGISTER_RESULT.DOWNLOAD_FILE(id), {
    responseType: 'blob',
    params: {
      filename,
      type,
    },
  });

export const createRegisterResultReview = ({ id, body }) =>
  instance.post(REGISTER_RESULT.CREATE_REVIEW(id), body);

export const updateRegisterResultReview = ({ id, reviewId, body }) =>
  instance.patch(REGISTER_RESULT.UPDATE_REVIEW(id, reviewId), body);

export const changeRegisterResultStatus = ({ id, body }) =>
  instance.post(REGISTER_RESULT.CHANGE_STATUS(id), body);

export const getRegisterResultReviews = (id) => instance.get(REGISTER_RESULT.GET_REVIEWS(id));

export const getRegisterResultReviewHistories = (id) =>
  instance.get(REGISTER_RESULT.GET_REVIEW_HISTORIES(id));

export const downloadRegisterResultDocxTemplate = (body) =>
  instance.post(REGISTER_RESULT.DOWNLOAD_DOCX_TEMPLATE, body, { responseType: 'blob' });

export const downloadRegisterResultDocxFile = (body) =>
  instance.post(REGISTER_RESULT.DOWNLOAD_DOCX_FILE, body, { responseType: 'blob' });

export const downloadRegisterResultPdfTemplate = (body) =>
  instance.post(REGISTER_RESULT.DOWNLOAD_PDF_TEMPLATE, body, { responseType: 'blob' });

export const downloadRegisterResultPdfFile = (body) =>
  instance.post(REGISTER_RESULT.DOWNLOAD_PDF_FILE, body, { responseType: 'blob' });
